import { ShowFor, Size } from "@brightagency/headstart-common";
import React, { FunctionComponent, ReactChild } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import { scrollToElementId } from "../../utils";
import { LegacyBrowserPopup } from "../molecules/LegacyBrowserPopup";
import { OutsideAustraliaNotification } from "../molecules/OutsideAustraliaNotification";
import { PWAInstallPrompt } from "../molecules/PWAInstallPrompt";
import { RegionSelectModal } from "../molecules/RegionSelectModal";
import { ErrorBoundary } from "../organisms/ErrorBoundary";
import { Footer } from "../organisms/Footer";
import { ListingItemModal } from "../organisms/ListingItemModal";
import { Nav } from "../organisms/Nav";
import { NavWrapper } from "../organisms/NavWrapper";
import { TopBar } from "../organisms/TopBar";


const PageBaseWrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: white;
`;

interface Props {
    children: ReactChild;
}

export const PageBase: FunctionComponent<Props> = props => {
    const history = useHistory();

    React.useEffect(() => {
        if (history.location.hash) {
            scrollToElementId(history.location.hash);
        }
    }, [history.location.hash]);

    return (
        <ErrorBoundary>
            <PageBaseWrapper>
                <TopBar />
                <NavWrapper>
                    <Nav />
                </NavWrapper>
                {props.children}
                <Footer />
                <ListingItemModal />
                <ShowFor size={Size.large}>
                    {/* <FeedbackButton /> */}
                </ShowFor>
                <OutsideAustraliaNotification />
                <LegacyBrowserPopup />
                <PWAInstallPrompt />
                <RegionSelectModal />
            </PageBaseWrapper>
        </ErrorBoundary>
    );
};
